import { useTimer } from 'react-timer-hook';

function MyTimer({ expiryTimestamp }) {
    const {
      seconds,
      minutes,
      hours,
      days,
    } = useTimer({ expiryTimestamp, onExpire: () => console.warn('onExpire called') });
    return (
        <div>
          <div>
            <span>{days}</span>d <span>{hours}</span>h <span>{minutes}</span>m <span>{seconds}</span>s
          </div>         
          
        </div>
      );
    }
    
    export default function App() {
      const time = new Date();
      time.setSeconds(time.getSeconds() + 6000); // 1hora timer
      return (
        <div>
          <MyTimer expiryTimestamp={time} />
        </div>
      );
    }